var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('p', {
    staticClass: "display px-4 mb-10 primary--text"
  }, [_vm._v(_vm._s(_vm.$t('Standpic')))]), _c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, [_c('v-dialog', {
    attrs: {
      "max-width": "290"
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [!_vm.isLoadingDb ? _c('v-card', [_c('v-card-title', {
    staticClass: "text-h5"
  }, [_vm._v("DBをダウンロードしますか?")]), _c('v-card-text', [_vm._v("この処理には時間がかかることがあります")]), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "text": ""
    },
    on: {
      "click": function click($event) {
        _vm.dialog = false;
      }
    }
  }, [_vm._v("No")]), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "text": ""
    },
    on: {
      "click": function click($event) {
        return _vm.loadAssetBundle();
      }
    }
  }, [_vm._v("Yes")])], 1)], 1) : _c('v-card', [_c('v-card-title', {
    staticClass: "text-h5"
  }, [_vm._v("DBダウンロード中... "), _c('v-progress-circular', {
    staticClass: "ml-3",
    attrs: {
      "indeterminate": ""
    }
  })], 1)], 1)], 1)], 1), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "lg": "6"
    }
  }, [_c('v-select', {
    staticClass: "px-4",
    attrs: {
      "label": _vm.$t('Character') + " (".concat(_vm.characters.length, ")"),
      "dense": "",
      "items": _vm.characters.map(function (item, i) {
        return {
          text: item.m_ADVCharaID,
          value: i
        };
      })
    },
    model: {
      value: _vm.characterID,
      callback: function callback($$v) {
        _vm.characterID = $$v;
      },
      expression: "characterID"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "lg": "3"
    }
  }, [_c('v-select', {
    staticClass: "px-4",
    attrs: {
      "label": _vm.$t('Pose') + " (".concat(_vm.poses.length, ")"),
      "dense": "",
      "items": _vm.poses.map(function (item, i) {
        return {
          text: i,
          value: i
        };
      })
    },
    model: {
      value: _vm.poseID,
      callback: function callback($$v) {
        _vm.poseID = $$v;
      },
      expression: "poseID"
    }
  })], 1), _c('v-col', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "cols": "12",
      "sm": "6",
      "lg": "3"
    }
  }, [_c('v-select', {
    staticClass: "px-4",
    attrs: {
      "label": _vm.$t('Face') + " (".concat(_vm.faces.length, ")"),
      "dense": "",
      "items": _vm.faces.map(function (item, i) {
        return {
          text: "".concat(item.key[2]),
          value: i
        };
      })
    },
    model: {
      value: _vm.faceID,
      callback: function callback($$v) {
        _vm.faceID = $$v;
      },
      expression: "faceID"
    }
  }), _c('v-overlay', {
    attrs: {
      "absolute": "",
      "value": _vm.loading,
      "opacity": "0"
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1)], 1)], 1), _c('v-list-item', {
    attrs: {
      "target": "_blank",
      "href": _vm.$const.sites.standpic.format(_vm.base)
    }
  }, [_c('v-list-item-title', {
    staticClass: "primary--text"
  }, [_vm._v(_vm._s(_vm.base) + " - " + _vm._s(_vm.$t('Assets.Title')))]), _c('v-list-item-action', {
    staticClass: "ma-0"
  }, [_c('v-icon', [_vm._v("mdi-open-in-new")])], 1)], 1), _c('v-divider', {
    staticClass: "mb-4"
  }), _c('div', {
    staticClass: "px-4 float-right"
  }, [_c('v-btn', {
    staticClass: "ml-2",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function click($event) {
        _vm.scale *= 0.8;
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-magnify-minus")])], 1), _c('v-btn', {
    staticClass: "ml-2",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function click($event) {
        _vm.scale = 1;
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-magnify-close")])], 1), _c('v-btn', {
    staticClass: "ml-2",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function click($event) {
        _vm.scale /= 0.8;
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-magnify-plus")])], 1), _vm.downloading ? _c('v-progress-circular', {
    staticClass: "ml-4 mr-2",
    attrs: {
      "indeterminate": "",
      "size": "20",
      "width": "3"
    }
  }) : _c('v-btn', {
    staticClass: "ml-2",
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.downloadImg
    }
  }, [_c('v-icon', [_vm._v("mdi-download")])], 1)], 1), _c('div', {
    staticStyle: {
      "width": "100%",
      "overflow": "hidden",
      "position": "relative"
    },
    style: {
      height: _vm.scale * 1200 + 'px'
    }
  }, [_c('div', {
    staticStyle: {
      "position": "absolute",
      "left": "50%",
      "transform": "translateX(-50%)"
    }
  }, [_c('div', {
    key: _vm.id,
    style: {
      transform: "scale(".concat(_vm.scale, ") translateY(").concat((_vm.scale - 1) * 50 / _vm.scale, "%)")
    }
  }, [_vm._m(0)])])])], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "d-inline-block"
  }, [_c('canvas', {
    staticClass: "standpic"
  })]);
}]

export { render, staticRenderFns }